import { useEffect, useRef } from 'react'
import { DossierProgression } from '../../shared/types'

// OLD
const useDossierProgress = (progress: DossierProgression | undefined) => {
  useEffect(() => {
    // chat: lets update this to return if there are no changes
    if (!progress) return

    console.log(' $$$ useDossierProgress() $$$', progress)

    if (progress.chapterComplete) {
      console.log('✅ Chapter complete:', progress.newChapterId)
      // TODO: show chapter complete modal or transition
    }

    if (progress.caseComplete) {
      console.log('🎉 Case complete')
      // TODO: show case completion animation, navigate, etc.
    }

    // You can extend this to trigger sounds, toasts, confetti, etc.
  }, [progress])
}

/**
 * Reacts to progression updates.
 * Triggers side effects like modals, transitions, or UI updates.
 *
 * @param progress - The response object returned from fetchPOIById or fetchSceneById
 */
interface DossierProgress {
  chapterComplete?: boolean
  caseComplete?: boolean
  newChapterId?: string
}

// const useDossierProgress = (progress?: DossierProgress) => {
//   const lastProgressRef = useRef<DossierProgress>()

//   useEffect(() => {
//     if (!progress) return

//     // Prevent running if same progress object (shallow)
//     // You can replace JSON.stringify() with a real deep comparison util like lodash.isEqual if needed — but for small objects, this is fine.
//     const isSame =
//       JSON.stringify(progress) === JSON.stringify(lastProgressRef.current)
//     if (isSame) return
//     // Store current progress for future comparisons
//     lastProgressRef.current = progress

//     console.log(' $$$ useDossierProgress() $$$', progress)

//     if (progress.chapterComplete) {
//       console.log('✅ Chapter complete:', progress.newChapterId)
//       // TODO: show chapter complete modal or transition
//     }

//     if (progress.caseComplete) {
//       console.log('🎉 Case complete')
//       // TODO: show case completion animation, navigate, etc.
//     }

//     // Extend this to trigger sounds, toasts, confetti, etc.
//   }, [progress])
// }

export default useDossierProgress

// OPTION 2
// interface UseDossierProgressProps {
//   scene?: {
//     chapterComplete?: boolean
//     caseComplete?: boolean
//   }
//   onChapterComplete?: () => void
//   onCaseComplete?: () => void
// }

// export const useDossierProgress = ({
//   scene,
//   onChapterComplete,
//   onCaseComplete,
// }: UseDossierProgressProps) => {
//   useEffect(() => {
//     if (scene?.chapterComplete) {
//       onChapterComplete?.()
//     }
//     if (scene?.caseComplete) {
//       onCaseComplete?.()
//     }
//   }, [scene, onChapterComplete, onCaseComplete])
// }
